/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './unmuteActor.defs.js'
export * as $defs from './unmuteActor.defs.js'
